import type { ScanServiceType, UnisonProjectTypeId } from '@witmetrics/utils';
import {
  SCAN_SERVICE_TYPE,
  UNISON_PROJECT_TYPE_ID,
} from '@witmetrics/utils/constants';

const {
  ALIGNERS,
  RETAINERS,
  NIGHTGUARD,
  BLEACHING_TRAY,
  VENEERS,
  ORTHO_MODELS,
  OTHER,
} = UNISON_PROJECT_TYPE_ID;
const {
  RETAINER_DIRECT_PRINTED_V1,
  MICHIGAN_SPLINT_V1,
  BLEACHING_TRAY_MODELS_V1,
  MODEL_BUILDER_V1,
} = SCAN_SERVICE_TYPE;

type CaseType = {
  projectTypeId: UnisonProjectTypeId;
  serviceTypeId?: ScanServiceType;
  title: string;
  description: string;
  src?: string;
};

export const CASE_TYPES: CaseType[] = [
  {
    projectTypeId: RETAINERS,
    serviceTypeId: RETAINER_DIRECT_PRINTED_V1,
    title: 'Retainers',
    description:
      'Retainer designs tailored for perfect fit and long-term stability.',
    src: '/images/cases/retainers.png',
  },
  {
    projectTypeId: NIGHTGUARD,
    serviceTypeId: MICHIGAN_SPLINT_V1,
    title: 'Nightguards',
    description:
      'AI-driven nightguard design with optimal fit, comfort and retention.',
    src: '/images/cases/splint.png',
  },
  {
    projectTypeId: BLEACHING_TRAY,
    serviceTypeId: BLEACHING_TRAY_MODELS_V1,
    title: 'Bleaching Trays',
    description: 'Optimized bleaching trays for superior whitening results.',
    src: '/images/cases/bleaching.png',
  },
  {
    projectTypeId: ORTHO_MODELS,
    serviceTypeId: MODEL_BUILDER_V1,
    title: 'Ortho Models',
    description: 'High-quality printable models ready for labs and production.',
    src: '/images/cases/printable.png',
  },
  {
    projectTypeId: ALIGNERS,
    title: 'Aligners',
    description:
      'Clear, staged aligner sets designed for predictable movement.',
    src: '/images/cases/aligners.png',
  },
  {
    projectTypeId: VENEERS,
    title: 'Veneers',
    description: 'Natural-looking veneer designs tailored to each smile.',
    src: '/images/cases/veneers.png',
  },
  {
    projectTypeId: OTHER,
    title: 'Other',
    description: 'Start a custom case for any other appliance type.',
    src: '/images/cases/other.png',
  },
];
